var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.root},[_c('div',{class:_vm.$style.name},[_vm._v(_vm._s(_vm.name))]),_c('div',{class:_vm.$style.value},[_vm._v(_vm._s(_vm.filteredValue)),(_vm.isCurrency)?_c('IconBase',{attrs:{"color":'inherit',"name":'icon-currency-som',"size":"10"}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }